<i _ngcontent-c8="" class="fa fa-square" [ngClass]="{'online': asset.inError=='N','offline':asset.inError==='Y'}"

[title]="asset.inError==='N'?'Operational':'In Error'"></i> &nbsp;